// @flow
import Chat from 'brastrap/editorial/chat/Chat';
import { connect } from 'react-redux';
import { startChat } from 'shared/actions/live-help';

const mapDispatchToProps = dispatch => ({
  onClick: e => dispatch(startChat(e)),
});

export default connect(null, mapDispatchToProps)(Chat);
